import type {
  OpinionPoll,
  OpinionPollVoted,
  OpinionPollsListParams,
  OpinionResultParams,
} from '@/modules/opinions/types';
import { axiosInstance, delay } from '@/utils';
import { analytics } from '@/utils/analytics';
import { HELIKA_EVENT_TYPE } from '@/utils/helika';

export class OpinionsApi {
  static readonly KEY = 'opinions';

  static async getOpinions(
    params: OpinionPollsListParams,
  ): Promise<OpinionPoll[]> {
    const { data } = await axiosInstance.post(`/v1/opinion-polls/list`, params);
    return data.content;
  }

  static async getOpinionsById(
    id: string,
    lang = 'en',
  ): Promise<OpinionPollVoted> {
    const { data } = await axiosInstance.get(`/v1/opinion-polls/${id}/${lang}`);
    return data.content;
  }

  static async dislikeOpinion(params: { id: string }) {
    await axiosInstance.post(`/v1/opinion-polls/${params.id}/dislike`);
  }

  static async requestAdReward() {
    return await axiosInstance.post(`/v1/ad-view-rewards/create`);
  }

  static async setOpinionResult(
    params: OpinionResultParams,
  ): Promise<OpinionPollVoted> {
    const resultParams: Partial<OpinionResultParams> = {};

    if (params.itemId) resultParams.itemId = params.itemId;

    if (params.predictPercentage)
      resultParams.predictPercentage = +params.predictPercentage;

    if (params.askerCode) resultParams.askerCode = params.askerCode;

    await delay(500);
    const { data } = await axiosInstance.post(
      `/v1/opinion-polls/${params.id}/vote`,
      resultParams,
    );

    if (data.content) {
      analytics.sendEvent({
        event_type: HELIKA_EVENT_TYPE.GAMEPLAY,
        event: {
          event_sub_type: 'opinion_voted',
          event_details: {
            event_label: 'Opinion voted',
            event_action: 'vote',
          },
          opinion_id: params.id,
        },
      });
    }

    return data.content;
  }
}
